import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, tap } from 'rxjs';
import { AbstractApiService } from '@core/services';
import { environment } from '@env/environment';
import { LocalizationService } from '../../../../internationalization/localization.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordForgetApiService extends AbstractApiService<object> {
  private translateService = inject(LocalizationService);

  constructor() {
    super(`${environment.backend?.url}/password-reset/forget`);
  }

  /**
   * Call forget password API and show toast message.
   * @param {string} email - User email.
   * @param {string} redirectUrl - Password reset page redirect URL.
   * @returns {Observable<void>} Observable.
   */
  forgetPassword(email: string, redirectUrl: string): Observable<void> {
    return this.httpClient.post(`${this.baseUrl}`, { email, redirectUrl }).pipe(
      tap((_: any) => {
        this.toastService.onHttpSuccess(this.getMessage('submitSuccess', 'successMessage'));
      }),
      catchError((error) => {
        const message = (error?.error?.error || [])[0]?.detail || error.message;
        const errorMessage = this.getMessage(message) || this.getMessage('submitError');
        this.toastService.onFormInvalid(errorMessage);
        return EMPTY;
      }),
    );
  }

  private getMessage(key: string, type: 'errorMessage' | 'successMessage' = 'errorMessage') {
    return ((this.translateService.translate(`passwordForget.${type}`) as unknown as Record<string, string>) || {})[
      key
    ];
  }
}
